import { defineComponent as _defineComponent } from 'vue'
import {
  ILineTypeCheckedMap,
  LineTypeCode,
  LineTypeName,
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  ShowToastMessage,
} from "@/types";
import LineTypeChip from "../shared/chip/LineTypeChip.vue";
import CheckboxInput from "../shared/inputs/CheckboxInput.vue";
import { inject, onMounted, ref } from "vue";
import { ILineType } from "@/domain/entities/lineInfo";
import { useLineStore } from "@/stores/lineStore";

interface ILineTypeCheck extends ILineType {
  checked?: boolean;
}


const __default__ = {
  name: "MapLineTypeFilter",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["onChangedLineTypeCheckedMap"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const emitOnChangedLineTypeChecked = () => {
  const checkedMap = Object.fromEntries(
    lineTypeCheckList.value.map((lineType) => [
      lineType.lineTypeCode,
      !!lineType.checked,
    ])
  );

  emit("onChangedLineTypeCheckedMap", checkedMap);
};

const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

const lineStore = useLineStore();

const lineTypeCheckList = ref<ILineTypeCheck[]>([]);
const getLineTypes = async () => {
  const result = await lineStore.getLineTypes();

  if (!result.isSuccess) {
    showToastMessage("노선 유형 목록 조회에 실패했습니다.", 3500);
    return;
  }

  lineTypeCheckList.value =
    result.data?.map((type) => ({
      ...type,
      checked: true,
    })) ?? [];

  emitOnChangedLineTypeChecked();
};

const onChangedCheck = (checked: boolean, index: number) => {
  const target = lineTypeCheckList.value[index];

  lineTypeCheckList.value[index] = {
    ...target,
    checked,
  };

  emitOnChangedLineTypeChecked();
};

onMounted(async () => {
  await getLineTypes();
});

const __returned__ = { emit, emitOnChangedLineTypeChecked, showToastMessage, lineStore, lineTypeCheckList, getLineTypes, onChangedCheck, LineTypeChip, CheckboxInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})